import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { SessionService } from "./session.service";
import { ApiService } from "./api.service";
import { CacheConfig, CacheConfigType} from '../classes/cache_config'
import {  map } from 'rxjs/operators';

@Injectable()
export class ApiRepository {

    private observableCache: { [key: string]: Observable<any> } = {};
    constructor(private sessionService: SessionService, private apiService: ApiService) {

  }

  post(data, config: CacheConfig) {
    let cachedData = this.tryToGetDataFromCache(config);
    if (cachedData) {
        return of(cachedData);
    }
    if (this.observableCache[config.getKey()]) return this.observableCache[config.getKey()];
    else this.observableCache[config.getKey()] = this.apiService.post(data).pipe(map(response => this.cacheData(response, config)));
    return this.observableCache[config.getKey()];
  }

  get(data, config: CacheConfig) {
    let cachedData = this.tryToGetDataFromCache(config);
    if (cachedData) {
        return of(cachedData);
    }
    if (this.observableCache[config.getKey()]) return this.observableCache[config.getKey()];
    else this.observableCache[config.getKey()] = this.apiService.get(data).pipe(map(response => this.cacheData(response, config)));
    return this.observableCache[config.getKey()];
  }

  getWithEncodedParams(api_url, params, config: CacheConfig) {
    let cachedData = this.tryToGetDataFromCache(config);
    if (cachedData) 
       return of(cachedData);
          
    if (this.observableCache[config.getKey()])  return this.observableCache[config.getKey()];
    else this.observableCache[config.getKey()] = this.apiService.getWithEncodedParams(api_url, params).pipe(map(response => this.cacheData(response, config)));
    return this.observableCache[config.getKey()];
  }


  private tryToGetDataFromCache(config: CacheConfig) {
      if (config) {
        if (config.invalidate === true) {
          if (config.type == CacheConfigType.MEMORY) {
            this.sessionService.dataCache.delete(config.getKey());
          } else if (config.type == CacheConfigType.SESSION) {
            this.sessionService.remove(config.getKey());
          }
        }
      }
      if (config.type == CacheConfigType.MEMORY) {
        return this.sessionService.dataCache.get(config.getKey());
      } else if (config.type == CacheConfigType.SESSION) {
        return this.sessionService.get(config.getKey());
      }
      return null;
  }

  private cacheData(response, config: CacheConfig) {
    this.observableCache[config.getKey()] = null;
      if (config.type == CacheConfigType.MEMORY) {
        this.sessionService.dataCache.set(config.getKey(), response);
      } else if (config.type == CacheConfigType.SESSION) {
        this.sessionService.set(config.getKey(), response);
      }
    return (response);
  }
  
}
